if (!customElements.get("cookie-banner")) {
  customElements.define(
    "cookie-banner",
    class CookieBanner extends HTMLElement {
      constructor() {
        super();
        const cookieClose = this.querySelector(".js-cookie-close");
        const cookieBanner = this.querySelector(".js-cookie-banner");

        cookieClose.addEventListener("click", () => {
          var now = new Date();
          var time = now.getTime();
          var expireTime = time + 1000 * 36000;
          now.setTime(expireTime);
          document.cookie =
            "cookiesConsentStatus=accepted;expires=" +
            now.toUTCString() +
            ";path=/";
          cookieBanner.classList.add("hide-cookie-banner");
        });
        // Get Cookies and loop through it in order to find the newsletter cookie
        const checkCookie = () => {
          var cookies = document.cookie.split(" ");
          var foundCookie = null;
          for (let prop in cookies) {
            if (cookies.hasOwnProperty(prop)) {
              if (cookies[prop].startsWith("cookiesConsentStatus=")) {
                foundCookie = cookies[prop];
                break;
              }
            }
          }

          if (foundCookie == "cookiesConsentStatus=accepted;") {
            cookieBanner.classList.add("hide-cookie-banner");
          }
        };

        checkCookie();
      }
    }
  );
}
